<template>
    <div class="content">
      <h1>Controller modding</h1>
      <p>Placeholder.</p>
    </div>

</template>


